import axios from "axios";
import { getExpectedUserType } from "../utils/authScope";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:5259/api",
  headers: {
    "Content-Type": "application/json",
    "X-Platform": "web",
  },
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("bigmarket_token");
  const rawAuth = localStorage.getItem("bigmarket_auth");

  if (token && rawAuth) {
    try {
      const { userType } = JSON.parse(rawAuth);
      // Only send the stored session's token on requests made from its own role
      // section - otherwise a session logged in elsewhere (e.g. business owner)
      // would get attached to requests made while browsing another role's pages.
      if (userType === getExpectedUserType(window.location.pathname)) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // ignore malformed stored auth
    }
  }

  return config;
});

export default axiosClient;
